export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const CREATE_PRINT_JOB = 'CREATE_PRINT_JOB'
export const GET_PRINTER_NAME_LIST = 'GET_PRINTER_NAME_LIST'
